<template>
  <tr>
    <div v-if="errorMessage" class="text-danger">{{ errorMessage }}</div>

    <td>{{ leave.user.name }}</td>
    <td>
      {{ moment(leave.from).format("DD.MM.yyyy") }} -
      {{ moment(leave.to).format("DD.MM.yyyy") }}
    </td>
    <td :title="leaveDaysObj.description">{{ leaveDaysObj.leavesAvailed }}</td>
    <td>{{ leave.description }}</td>
    <template v-if="leave.approved === null">
      <td>In Bearbeitung</td>
    </template>
    <template v-else-if="leave.approved === true">
      <td>Genehmigt</td>
    </template>
    <template v-else>
      <td>Abgelehnt</td>
    </template>
    <td>
      <a class="btn btn-danger" @click="deleteLeave(leave.id)">Löschen</a>
    </td>
    <td v-if="adminAccess">
      <input
        :id="`${leave.id}-true`"
        type="radio"
        v-bind:value="true"
        v-model="pick"
        v-on:click="onApprove($event)"
      />
      <label :for="`${leave.id}-true`">Genehmigt</label>
      <br />
      <input
        :id="`${leave.id}-false`"
        type="radio"
        v-bind:value="false"
        v-model="pick"
        v-on:click="onApprove($event)"
      />
      <label :for="`${leave.id}-false`">Abgelehnt</label>
      <br />
    </td>
    <div v-if="errorMessage" class="text-danger">{{ errorMessage }}</div>

  </tr>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import axios from "axios";
import moment from "moment";

export default {
  components: {},
  name: "leavesRow",
  props: ["leave", "leaveDaysObj"],
  data() {
    return {
      errorMessage: null,
      pick: null,
      moment: moment,
    };
  },
  computed: {
    ...mapGetters(["isAuthenticated", "authStatus", "getProfile"]),
    ...mapState({
      adminAccess: (state) => state.user.profile.adminAccess,
    }),
  },
  methods: {
    onApprove: function (event) {
      this.leave.approved = JSON.parse(event.target.value);
      axios({
        method: "POST",
        url: process.env.VUE_APP_API_PATH + "leaves/leaveUpdate/" + this.leave.id,
        data: this.leave,
      }).then((result) => {
        console.log(result);
      }),
        (error) => {
          console.error(error);
        };
    },
    deleteLeave: function (leaveId) {
      axios({
        method: "DELETE",
        url: process.env.VUE_APP_API_PATH + "leaves/" + leaveId,
      }).then(
        (result) => {
          this.$emit("deleteLeave", result.data.id);
        },
        (error) => {
          console.error(error);
          if (error.response) {
            this.errorMessage = error.response.data;
          } else {
            this.errorMessage = "An error occurred while deleting the leave.";
          }
        }
      );
    },
  },
};
</script>
